const womenLeggingsData = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1506629905607-d405b7a6e6d4?w=800",
    title: "Black Camo Leggings",
    price: 749,
    description: "High-waist squat-proof leggings designed for gym workouts and daily wear."
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800",
    title: "Teal Blue Leggings",
    price: 699,
    description: "Breathable stretch fabric with excellent flexibility."
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800",
    title: "Grey Flex Leggings",
    price: 749,
    description: "Premium performance leggings with moisture-wicking fabric."
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800",
    title: "Olive Green Leggings",
    price: 749,
    description: "Comfort fit leggings ideal for training and yoga."
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=800",
    title: "Mystery Blue Leggings",
    price: 699,
    description: "Stylish and lightweight leggings for active lifestyles."
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800",
    title: "Ice Blue Leggings",
    price: 699,
    description: "Soft-touch fabric with four-way stretch."
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?w=800",
    title: "Ocean Print Leggings",
    price: 699,
    description: "Unique printed design with maximum comfort."
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800",
    title: "Squat Proof Leggings",
    price: 699,
    description: "Engineered for gym performance and confidence."
  }
];

export default womenLeggingsData;